import PurchaseInWorkList from "./purchase-in-work-list";
import './purchase-in-work-mobile.css'
const PurchaseInWorkIndex = (props) => {
  return <PurchaseInWorkList />
}

export default PurchaseInWorkIndex


